import {CreateAccessor, GetDoc, GetDocs} from "mobx-graphlink";
import {StatView} from "./statViews/@StatView";
import {emptyArray} from "js-vextensions";

export const GetStatView = CreateAccessor((id: string): StatView|n=>{
	const result = GetDoc({}, a=>a.statViews.get(id));
	return CleanUpStatViewFromDB(result);
});
export const GetStatViews = CreateAccessor((userID: string|n): StatView[]=>{
	if (userID == null) return emptyArray; // if we aren't signed-in, don't even try to make request (the security-rules will make it fail) // edit: still keep, on new backend?
	let result = GetDocs({
		params: {filter: {creator: userID != null && {equalTo: userID}}},
	}, a=>a.statViews);
	//return result;
	return result.map(CleanUpStatViewFromDB); // edit: this still needed?
});

function CleanUpStatViewFromDB<T extends StatView|n>(view: T): T {
	if (view == null) return view;
	const fieldValsThatMayHaveKeyProp = [view.combined_yTypes_scales];
	for (const fieldVal of fieldValsThatMayHaveKeyProp) {
		if (fieldVal == null) continue;
		if ("_key" in fieldVal) {
			delete fieldVal["_key"];
		}
	}
	return view;
}